module.exports = __webpack_public_path__ + "img/bernhard-benke.918699fb.jpg";